import { ToastContainer } from 'react-toastify';
import { Router } from './routes';
import AppProvider from './hook';
import { ErrorBoundary } from './components/ErrorBoundary';
import 'react-toastify/dist/ReactToastify.css';

export function App() {
  return (
    <ErrorBoundary>
      <div className='min-h-screen dark:bg-zinc-900'>
        <AppProvider>
          <ToastContainer
            position='top-right'
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            containerId='toast'
          />
          <Router />
        </AppProvider>
      </div>
    </ErrorBoundary>
  );
}
